module.exports = __webpack_public_path__ + "img/5c.f87fffb5.png";